import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Holding, MultiPortfolioHoldingList } from 'clientportalshared';
import { ScreenState } from '@enums/index';
import { initiateHoldingsAsync } from './thunks';
import { GridFilterItem } from '@mui/x-data-grid-pro';
import { DateRange } from '../..';
import { DatePickerNames } from '@components/dateRange/DateRangePreDefinedDates';
import { DateTime } from 'luxon';

export interface HoldingsStore {
  state: ScreenState;
  data: MultiPortfolioHoldingList;
  filters: GridFilterItem[];
  clickedHolding?: Holding;
  asOfDate: DateRange;
  securityAsOfDate: DateRange;
}

const initialState = {
  asOfDate: {
    dateTo: DateTime.now().toISODate(),
    dateFrom: DateTime.now().toISODate(),
    dateRangeType: DatePickerNames.Today,
  },
  securityAsOfDate: {
    dateTo: '',
    dateFrom: '',
  },
  state: ScreenState.Loading,
} as HoldingsStore;

export const HoldingsSlice = createSlice({
  name: 'holdings',
  initialState,
  reducers: {
    setAsOfDate: (state, action: PayloadAction<DateRange>) => {
      state.asOfDate = action.payload;
    },
    setSecurityAsOfDate: (state, action: PayloadAction<DateRange>) => {
      state.securityAsOfDate = action.payload;
    },
    setHoldingFilters: (state, action: PayloadAction<GridFilterItem[]>) => {
      state.filters = action.payload;
    },
    setHoldingsLoading: (state) => {
      state.state = ScreenState.Loading;
    },
    setHoldingsResult: (state, action: PayloadAction<MultiPortfolioHoldingList>) => {
      state.state = ScreenState.SuccessDataLoaded;
      state.data = action.payload;
    },
    setHoldingsError: (state) => {
      state.state = ScreenState.ErrorUnableToLoadData;
    },
  },
  extraReducers(builder) {
    builder.addCase(initiateHoldingsAsync.pending, (state) => {
      state.state = ScreenState.Loading;
    });
    builder.addCase(initiateHoldingsAsync.rejected, (state) => {
      state.state = ScreenState.ErrorUnableToLoadData;
    });
  },
});

export const { setAsOfDate, setHoldingFilters, setSecurityAsOfDate, setHoldingsLoading, setHoldingsResult, setHoldingsError } = HoldingsSlice.actions;

export default HoldingsSlice.reducer;
